export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14119.b498cb1d.jpg";